import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * PaperPlane icon
 *
 * @category Business
 */
const PaperPlane = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <g clip-path="url(#paper-plane-a)">
          <path
            fill="currentColor"
            stroke="currentColor"
            stroke-width=".175"
            d="M19.915 29.39c.35-.197.616-.883.784-1.373 1.421-4.46 6.028-17.51 7.225-21.801.329-2.15-3.032-.175-4.586.175-1.666.56-3.724 1.26-5.88 1.988-3.837 1.302-9.277 3.116-12.49 4.229-.582.217-1.583.7-.82 1.295 2.191 1.421 6.126 2.415 8.674 3.508 1.436.455 2.388 1.183 2.822 2.611.686 1.736 1.953 5.258 2.737 7.302.266.77 1.1 2.388 1.492 2.08l.049-.021zM26.25 6.237s.077.035.056.07c-1.828 2.15-7.148 7.148-10.005 10.046-.938.994-2.254.476-3.34.05-2.135-.82-4.718-1.667-6.735-2.535-.343-.175-.707-.371-.329-.61 3.207-1.12 18.665-6.426 20.374-7.014zm-10.005 11.53c.098-.28.301-.524.497-.748.61-.694 1.267-1.338 1.918-1.989 1.38-1.38 2.766-2.751 4.145-4.116l2.065-2.066c.21-.21 1.87-2.037 2.038-1.94.147.092-.756 2.395-.854 2.675l-.945 2.766-1.884 5.538-3.178 9.353c-.028.098-.077.203-.161.245-.19.091-.372-.147-.448-.336-1.114-2.737-2.227-5.489-3.102-8.31-.084-.28-.175-.567-.133-.861q.02-.107.049-.203z"
          />
        </g>
        <defs>
          <clipPath id="paper-plane-a">
            <path fill="currentColor" d="M0 0h32v32H0z" />
          </clipPath>
        </defs>
      </svg>
    );
  }
);

PaperPlane.displayName = 'PaperPlane';

export { PaperPlane };
